import React, { Component } from 'react';
import './List.scss';
import ChildListItem from './ChildList/ChildListItem';
import { connect } from 'react-redux';
import { fetchChildrenList } from '../Actions/ChildrenList';
import Pagination from 'react-js-pagination';
import GiftBar from '../Component/GiftBar';
import ForScreen from './ForScreen';
import { Link } from 'react-router-dom';
import SearchBar from '../Component/SearchBar';

class List extends Component {
  pageSize = 5;

  state = { children: [], term: '', filteredResults: [], isFiltered: false };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      totalWish: 10
    };
  }

  componentWillMount() {
    let pageId = parseInt(this.props.match.params.page, 10);
    if (!pageId) {
      pageId = 1;
    }
    this.setState({
      currentPage: pageId
    });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page,
      totalWish: page * 10
    });

    this.props.history.push(`/list/${page}`);
  };

  onSearchSubmit = term => {
    const filtered = this.props.childrenList.filter(it => {
      return it.listname.toLowerCase().includes(term.toLowerCase());
    });
    this.setState(() => {
      return {
        term,
        filteredResults: filtered,
        isFiltered: true
      };
    });
  };

  pagination = () => {
    return (
      <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 text-center">
        <Pagination
          className="pagination"
          activePage={this.state.currentPage}
          itemsCountPerPage={this.pageSize}
          totalItemsCount={this.props.childrenList.length}
          onChange={this.handlePageChange}
          prevPageText={<i className="far fa-chevron-left" />}
          nextPageText={<i className="far fa-chevron-right" />}
          hideFirstLastPages={true}
        />
      </div>
    );
  };

  paginationAfterSearch = () => {
    if (this.state.term.length === 0) {
      this.setState({
        isFiltered: false
      });
      return this.pagination();
    }
  };

  renderContent = () => {
    if (this.props.fetching) {
      return (
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 text-center">
            <i className="fa fa-spinner fa-spin fa-2x" />
            <br />
            <h3>Laden...</h3>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <SearchBar onSubmit={this.onSearchSubmit} />
        <ForScreen desktop>
          <GiftBar
            countWishes={this.props.numberOfWishes}
            countFulfilledWishes={this.props.numberOfFulfilledWishes}
            numberOfGifts={10}
          />
        </ForScreen>
        <ForScreen mobile>
          <GiftBar
            countWishes={this.props.numberOfWishes}
            countFulfilledWishes={this.props.numberOfFulfilledWishes}
            numberOfGifts={5}
          />
        </ForScreen>
        <div className="row text-center">
          <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1">
            {this.state.filteredResults &&
              this.state.filteredResults.map(child => {
                return <ChildListItem child={child} key={child.id} />;
              })}
            {!this.state.isFiltered &&
              this.props.childrenList
                .slice(
                  (this.state.currentPage - 1) * this.pageSize,
                  this.state.currentPage * this.pageSize
                )
                .map((child, i) => {
                  return <ChildListItem child={child} key={i} />;
                })}
            {!this.state.isFiltered
              ? this.pagination()
              : this.paginationAfterSearch()}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    let title = 'Machen Sie ein Kind zu Heilig Abend glücklich!';
    let subTitle =
      'Wunsch aussuchen und allein oder im Bündnis mit Freund*innen oder Großfamilie diesen Wunsch erfüllen, das Geschenk einpacken und in der Lutherkirche abgeben.';

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 text-center">
            <h2 className="section-header">{title}</h2>
            <p className="section-header-subtitle">
              {subTitle}
              <Link to={'/howto'}>
                <br />
                Mehr Info <i className="far fa-long-arrow-right" />
              </Link>
            </p>
          </div>
        </div>
        {this.renderContent()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    childrenList: state.childrenListReducer.list,
    numberOfWishes: state.childrenListReducer.numberOfWishes,
    numberOfFulfilledWishes: state.childrenListReducer.numberOfFulfilledWishes,
    fetching: state.childrenListReducer.fetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchChildrenList: () => dispatch(fetchChildrenList())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(List);



// WEBPACK FOOTER //
// ./src/Containers/List.js